"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const react_responsive_1 = require("react-responsive");
const reducers_1 = require("../../../../reducers");
const FormSection_1 = require("../../../utils/FormSection");
const APITriggerPreview_1 = require("./APITriggerPreview");
const FieldSelector_1 = require("./FieldSelector");
const APITrigger = ({ device, editableCampaign, currentWizard, currentPage, }) => {
    return (React.createElement(FormSection_1.default, { device: device, style: { marginTop: 24 } },
        React.createElement(src_1.Text, { text: "API Trigger", size: "h1", textStyle: { marginBottom: 8 } }),
        React.createElement("div", { style: {
                width: '100%',
                padding: '24px 0 23px',
                borderBottom: `1px solid ${src_1.titanium}`,
            } },
            React.createElement(src_1.Text, { text: "Campaign ID", size: "small", label: true, textStyle: { color: src_1.steel } }),
            React.createElement(src_1.Copiable, { copiableText: editableCampaign.id, placement: "left" },
                React.createElement(src_1.Text, { text: editableCampaign.id, size: "large", textStyle: { width: '100%' } }))),
        React.createElement(src_1.Text, { text: "Custom Fields", size: "h2", textStyle: { marginTop: 47, marginBottom: 8 } }),
        React.createElement(src_1.Text, { text: "Optional data fields that can be added to the API payload when triggering the campaign. The values of these fields can be used to customize the notification and experience content.", size: "small", textStyle: {
                paddingBottom: 23,
                borderBottom: `1px solid ${src_1.titanium}`,
            } }),
        React.createElement(FieldSelector_1.default, { device: device }),
        React.createElement(react_responsive_1.default, { minWidth: 1140 }, device === 'Desktop' &&
            currentWizard === 'delivery' &&
            currentPage === 'apiTrigger' &&
            ReactDOM.createPortal(React.createElement(APITriggerPreview_1.default, null), document.getElementById('mainModalRight')))));
};
const mapStateToProps = (state) => ({
    currentWizard: reducers_1.getCurrentWizard(state),
    currentPage: reducers_1.getCurrentFormPage(state),
    editableCampaign: reducers_1.getEditableCampaign(state),
});
exports.default = react_redux_1.connect(mapStateToProps, {})(APITrigger);
